import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import SiteLayout from "@/components/site/SiteLayout";
import CmsPage, { PagePreview } from "@/pages/public/CmsPage";
import Legal from "@/pages/public/Legal";
import NotFound from "@/pages/public/NotFound";
import GalleryDetail from "@/pages/public/GalleryDetail";
import ClientLogin from "@/pages/client/ClientLogin";
import ClientArea from "@/pages/client/ClientArea";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import Contacts from "@/pages/admin/Contacts";
import Quotes from "@/pages/admin/Quotes";
import { PortfolioAdmin, ReviewsAdmin, SettingsAdmin, ClientAreaAdmin } from "@/pages/admin/Resources";
import PagesAdmin from "@/pages/admin/PagesAdmin";
import PageEditor from "@/pages/admin/PageEditor";
import MenuAdmin from "@/pages/admin/MenuAdmin";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<SiteLayout />}>
            <Route path="/" element={<CmsPage slug="home" />} />
            <Route path="/portfolio/:slug" element={<GalleryDetail />} />
            <Route path="/privacy-policy" element={<Legal doc="privacy" />} />
            <Route path="/cookie-policy" element={<Legal doc="cookie" />} />
            <Route path="/termini-e-condizioni" element={<Legal doc="termini" />} />
            <Route path="/area-clienti" element={<ClientLogin />} />
            <Route path="/area-clienti/evento" element={<ClientArea />} />
            <Route path="/anteprima/:id" element={<PagePreview />} />
            <Route path="/:slug" element={<CmsPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="pagine" element={<PagesAdmin />} />
            <Route path="pagine/:id" element={<PageEditor />} />
            <Route path="menu" element={<MenuAdmin />} />
            <Route path="portfolio" element={<PortfolioAdmin />} />
            <Route path="area-clienti" element={<ClientAreaAdmin />} />
            <Route path="recensioni" element={<ReviewsAdmin />} />
            <Route path="preventivi" element={<Quotes />} />
            <Route path="contatti" element={<Contacts />} />
            <Route path="impostazioni" element={<SettingsAdmin />} />
            <Route path="*" element={<Navigate to="/admin" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" toastOptions={{ style: { borderRadius: 4, fontFamily: "Manrope" } }} />
    </AuthProvider>
  );
}

export default App;
